import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import ProductList from './ProductList';
import ProductLocationList from './ProductLocationList';
import ProductCodeList from './ProductCodeList';
import PageHeader from '../../components/layout/PageHeader';
import TabPanel from '../../components/layout/TabPanel';

const ProductsPage: React.FC = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <Box>
      <PageHeader title="Produtos" subtitle="Gerir o catálogo de produtos e os artigos em inventário." />
      
      <Tabs value={tabValue} onChange={handleTabChange} aria-label="separadores de vista de produtos">
        <Tab label="Todos os produtos" />
        <Tab label="Por local" />
        <Tab label="Por código" />
      </Tabs>
      
      <TabPanel value={tabValue} index={0} idPrefix="product">
        <ProductList />
      </TabPanel>
      <TabPanel value={tabValue} index={1} idPrefix="product">
        <ProductLocationList />
      </TabPanel>
      <TabPanel value={tabValue} index={2} idPrefix="product">
        <ProductCodeList />
      </TabPanel>
    </Box>
  );
};

export default ProductsPage;
